/**
 * Advance to the next page of reviews when the load-more button is clicked.
 * Hides the button when all reviews have been revealed.
 * @param loadMoreBtn The load-more button element that tracks the current page via a data attribute.
 * @param reviews The full list of review elements to be paged through.
 * @param pageSize The maximum number of reviews to display per page.
 */
function loadMore(loadMoreBtn, reviews, pageSize) {
    var _a;
    let page = parseInt((_a = loadMoreBtn.dataset['page']) !== null && _a !== void 0 ? _a : '0') + 1;
    ReviewPagePaging.showHideReviews(reviews, pageSize, page, loadMoreBtn);
    loadMoreBtn.dataset['page'] = page.toString();
}
export class ReviewPagePaging {
    /**
     * Initialise paging for the review container by attaching a click listener to the
     * load-more button and showing the first page of reviews.
     * @param reviewContainer The review container element that holds the paging controls.
     * @param pageSize The maximum number of reviews to display per page.
     * @param reviews The full list of review elements to be paged.
     */
    static setupPaging(reviewContainer, pageSize) {
        const reviews = reviewContainer.querySelectorAll('.review');
        const loadMoreBtn = reviewContainer.querySelector('.load-more-button');
        if (loadMoreBtn != null) {
            loadMoreBtn.addEventListener('click', () => {
                loadMore(loadMoreBtn, reviews, pageSize);
            });
        }
        ReviewPagePaging.showHideReviews(reviews, pageSize, 0, loadMoreBtn);
    }
    /**
     * Show reviews up to the given page number and hide the rest.
     * Reviews carrying the ignore class are excluded from the visible count so that
     * filtered-out items do not consume page slots.
     * Also updates the visibility of the load-more button if one is provided.
     * @param reviews The full list of review elements.
     * @param pageSize The maximum number of reviews to display per page.
     * @param pageNumber The zero-based index of the last page to display (inclusive).
     * @param loadMoreBtn The load-more button whose visibility is updated after paging. Pass null to skip.
     */
    static showHideReviews(reviews, pageSize, pageNumber, loadMoreBtn = null) {
        let count = 0;
        reviews.forEach((review) => {
            if (count < (pageSize * (pageNumber + 1))) {
                review.classList.remove('d-none');
            }
            else {
                review.classList.add('d-none');
            }
            if (!review.classList.contains('filtered-review')) {
                count++;
            }
        });
        if (loadMoreBtn != null) {
            const filteredReviews = Array.from(reviews).filter(review => !review.classList.contains('filtered-review'));
            if ((pageNumber + 1) * pageSize >= filteredReviews.length) {
                loadMoreBtn.classList.add('d-none');
            }
            else {
                loadMoreBtn.classList.remove('d-none');
            }
        }
    }
}
